import Constants from '../../../Constants';

export const LANGUAGE_OPTIONS = [
  {
    label: 'Python',
    value: Constants.CodeLanguages.PYTHON,
  },
  {
    label: 'JavaScript',
    value: Constants.CodeLanguages.JAVASCRIPT,
  },
];

export const LANGUAGE_DEFAULTS = {
  [Constants.CodeLanguages.PYTHON]: `def transformAttribute(input, metadata, args):
  # Sample python transform to return 'hello world'
  return 'hello world'`,
  [Constants.CodeLanguages.PYTHON3]: `def transformAttribute(input, metadata, args):
  # Sample python 3 transform to return 'hello world'
  return 'hello world'`,
  [Constants.CodeLanguages.JAVASCRIPT]: `function transformAttribute(input, metadata, args) {
    // Sample javascript transform to return 'hello world'
    return 'hello world';
}`,
};

export const ATTR_TX_INPUT_SAMPLES = '{\n\t"ID": 1,\n\t"NAME": "A"\n}';

export const RECORD_LANGUAGE_OPTIONS = [
  {
    label: 'Python',
    value: Constants.CodeLanguages.PYTHON,
  },
  {
    label: 'JavaScript',
    value: Constants.CodeLanguages.JAVASCRIPT,
  },
  {
    label: 'Nexla JSON',
    value: Constants.CodeLanguages.JOLT,
  },
];

export const RECORD_LANGUAGE_DEFAULTS = {
  [Constants.CodeLanguages.JOLT]: `[]`,
  [Constants.CodeLanguages.PYTHON]: `def transform(input, metadata, args):
  # Sample python transform to pass all attributes through
  return input`,
  [Constants.CodeLanguages.PYTHON3]: `async def transform(input, metadata, args):
  # Sample python 3 transform to pass all attributes through
  return input`,
  [Constants.CodeLanguages.JAVASCRIPT]: `function transform(input, metadata, args) {
    // Sample javascript transform to pass all attributes through
    return input;
}`,
};

export const RECORD_TX_INPUT_SAMPLES =
  '[{\n\t"ID": 1,\n\t"NAME": "A"\n},{\n\t"ID": 2,\n\t"NAME": "B"\n}]';
